import { BehaviorSubject } from 'rxjs';

import { CoordinatorService } from './coordinator.service';
import { XItem } from './x-item';

// import { SnapshotRequestParams } from "./snapshot-request-params";

declare const Papa: any;

interface ExportParams {
    filename?: string;
    asProject?: boolean;
    ls: XItem[];
}

export type EXPORT_TYPE =
    | 'databin'
    | 'databin-list'
    | 'project'
    | 'keyword-list'
    | 'comment-list'
    | 'binary-tree'
    | 'binary-tree-list'
    | 'collection'
    | 'view'
    | 'view-list'
    | 'pin'
    | 'pin-list'
    | 'style-list'
    | 'json-all';

export type OUTPAR = {
    filename?: string;
    headerLs: string[];
    rowLs: (string | number)[][];
};

export class Export$ {
    isExportChoice$ = new BehaviorSubject<boolean>(false);

    defaultName = 'patentka';

    constructor(private coords: CoordinatorService) {}

    onStart() {
        this.coords.worker$.export.response$.subscribe({
            next: (x) => this._workerResponse(x),
            error: (e) => console.log(e),
        });
    }

    csv(params: OUTPAR) {
        this._export(
            params.filename ? `${params.filename}.csv` : `${this.defaultName}.csv`,
            Papa.unparse({
                fields: params.headerLs,
                data: params.rowLs,
            }),
        );
    }

    private _htmlEnvelope(body: string) {
        return `<html>
        <head>
                <title>Patentka export</title>
        </head>
        <body>${body}</body>
        </html>`;
    }

    private _htmlTable(headerLs: string[], rowLs: (string | number)[][]) {
        const ls = ['<table>'];
        ls.push(`<tr>${headerLs.map((x) => `<th>${x}</th>`).join('\n')}</tr>`);
        rowLs.map((rLs) => {
            ls.push(`<tr>${rLs.map((x) => `<td>${x}</td>`).join('\n')}</tr>`);
        });
        ls.push('</table');
        return ls.join('\n');
    }

    html(params: OUTPAR) {
        this._export(
            params.filename ? `${params.filename}.html` : `${this.defaultName}.html`,
            this._htmlEnvelope(this._htmlTable(params.headerLs, params.rowLs)),
        );
    }

    exportActiveResultLs(
        tp:
            | 'memowl'
            | 'ris'
            | 'xls'
            | 'docx'
            | 'csv'
            | 'doi'
            | 'page'
            | 'ecomole'
            | 'csv-team-bt'
            | 'json-all'
            | 'json-identifiers',
    ) {
        const xitemLs = this.coords.resultList$.activeList$.getValue();

        // console.log('EXPORT ACTIVE RESULT LS', tp, xitemLs);

        switch (tp) {
            case 'memowl':
                return this.coords.script$.system$.exportItems(xitemLs);
            // return this.exportMemowl(xitemLs);
            case 'ris':
                return this.coords.script$.system$.exportRIS(xitemLs);
            // return this._exportRIS(xitemLs);
            case 'csv':
                return this.coords.script$.system$.exportCSV(xitemLs);
            case 'csv-team-bt':
                return this.coords.script$.system$.exportCSVTeam(this._allDataDct(xitemLs));

            // return this._exportCSV(xitemLs);
            case 'doi':
                return this.coords.script$.system$.exportDOI(xitemLs);
            // return this._exportDOI(xitemLs);
            case 'xls':
                return this._exportXLS(xitemLs);
            case 'docx':
                return this._exportDocx(xitemLs);
            case 'page':
                return this._exportPage(xitemLs);
            case 'json-all':
                return this._exportJSON_All(xitemLs);
            case 'json-identifiers':
                return this._exportJSON_identifiers(xitemLs);
            case 'ecomole':
                return this.exportEcomole(xitemLs);
            default:
        }
    }

    private _allDataDct(xitmLs: XItem[]) {
        const itemLs = xitmLs.map((xitm) => xitm.exportJsonAll());
        const users = this.coords.project$.current!.exportJsonAllTeam();
        const ratings = this.coords.binaryTree$.exportJsonAll('ratings');
        const tags = this.coords.binaryTree$.exportJsonAll('tags');
        const subsets = this.coords.view$.exportJsonAll();
        const resultDct = {
            itemLs,
            userList: users,
            subsetList: subsets,
            ratingsList: ratings,
            tagsList: tags,
        };
        return resultDct;
    }

    private _exportJSON_All(xitmLs: XItem[]) {
        const resultDct = this._allDataDct(xitmLs);
        // console.log('111 EXPORT JSON ALL', resultDct);
        this.coords.filesystem$.saveFile2(
            'export-all.json',
            new Blob([JSON.stringify(resultDct)], {
                type: 'application/json',
            }),
        );
    }
    private _exportJSON_identifiers(xitmLs: XItem[]) {
        const resultDct: { [tag: string]: string[] } = {};
        xitmLs.forEach((xitm) => {
            resultDct[xitm.id] = xitm.exportIdentifiers();
        });

        // console.log('111 EXPORT JSON ALL', resultDct);
        this.coords.filesystem$.saveFile2(
            'export-identifiers.json',
            new Blob([JSON.stringify(resultDct)], {
                type: 'application/json',
            }),
        );
    }

    private _exportPage(xitemLs: XItem[]) {
        this.coords.filesystem$.saveFile2(
            'page.json',
            new Blob(
                [
                    JSON.stringify({
                        sourceId: this.coords.project$.current?.id,
                        xitemLs: xitemLs.map((xitm) => xitm.save()),
                    }),
                ],
                {
                    type: 'application/json',
                },
            ),
        );
    }

    // exportMemowl(xitemLs: XItem[], title?: string) {
    //     if (!title) title = 'selection';
    //     const payload = xitemLs.map((xitm) => xitm.save());
    //     this.coords.filesystem$.saveImportFile(`${title}.m`, 'xitem-list', payload);
    // }

    // private _exportCSV(xitemLs: XItem[]) {
    //     const payload = xitemLs.map((xitm) => xitm.save());

    //     this.coords.worker$.parser.directPost({
    //         action: 'export-csv',
    //         payload: payload,
    //     });
    // }

    private _exportXLS(xitemLs: XItem[]) {
        const payload = xitemLs.map((xitm) => xitm.save());

        this.coords.worker$.parser.directPost({
            action: 'create-excell',
            payload: payload,
        });
    }

    private _exportDocx(xitemLs: XItem[]) {
        const payload = xitemLs.map((xitm) => xitm.save());

        this.coords.worker$.parser.directPost({
            action: 'create-docx',
            payload: payload,
        });
    }

    // private _exportDOI(xitemLs: XItem[]) {
    //     this.coords.filesystem$.saveFile2(
    //         'selection-doi-list.txt',
    //         new Blob(
    //             [
    //                 xitemLs
    //                     .map((xitm) => xitm.get('doi'))
    //                     .filter((x) => x)
    //                     .join('\n'),
    //             ],
    //             {
    //                 type: 'text/plain',
    //             },
    //         ),
    //     );
    // }

    // private _exportRIS(xitemLs: XItem[]) {
    // const ls: string[] = ['FN Clarivate Analytics Web of Science\nVR 1.0'];
    // xitemLs.forEach((x) => ls.push(x.exportRIS()));
    // this.coords.filesystem$.saveFile2(
    //     'selection.ris',
    //     new Blob([ls.join('\n\n')], {
    //         type: 'application/x-research-info-systems',
    //     }),
    // );
    // }

    exportSuggestion(suggestDict: any) {
        this._export(
            'suggest.json',
            JSON.stringify(['https://memowl.com/suggestion', suggestDict]),
        );
    }

    exportEcomole(ls: XItem[]) {
        const resp = [
            'ecomole_items_v1',
            {
                type: 'dataset',
                title: this.coords.project$.current?.title,
                dbMeta: {},
                id: this.coords.uniqueId(),
                itemLs: ls.map((x) => x.exportEcomole()),
            },
        ];

        this.coords.filesystem$.saveFile2(
            'export.json',
            new Blob([JSON.stringify(resp)], {
                type: 'application/json',
            }),
        );
    }

    // exportRIS(params: ExportParams) {
    //     this._export(params.filename || `${this.defaultName}.ris`,
    //         `FN Clarivate Analytics Web of Science\nVR 1.0\n\n${params.ls
    //             .map(x => x.xitem.exportRIS()).join("\n\n")}`)
    // }

    private _export(fn: string, payload: any) {
        this.coords.saveFile(fn, payload);
        // this.coords.filesystem$.filesystemService.save({
        //     isRaw: true,
        //     filename: fn,
        //     payload: payload
        // })
    }

    private _saveFile(params: any) {
        // console.log("%c EXPORT READY", this.coords.consoleEm("linen", "mediumblue"), params)

        this.coords.filesystem$.saveFile2(params.filename, params.payload);
    }

    private _workerResponse(params: any) {
        // console.log(1111, params)
        switch (params.action) {
            case 'save-file':
                return this._saveFile(params.payload);
            case 'success':
                return;

            default:
                this.coords.utils$.consoleInfo({
                    tag: 'EXPORT Response',
                    payload: params,
                    color: 'orange',
                    background: 'blue',
                });
        }
    }

    export(
        type: EXPORT_TYPE,
        filename: string,
        exportLs: [string, string[]][],
        meta?: { [t: string]: string },
    ) {
        this.post('export', {
            projectId: this.coords.project$.currentId,
            type: type,
            meta: meta,
            filename: filename,
            exportLs: exportLs,
        });
    }

    post(action: string, payload: any) {
        this.coords.worker$.export.directPost({
            action: action,
            payload: payload,
        });
    }
}
